module.exports = __webpack_public_path__ + "img/domain-03.1b42a7ba.png";